import React from "react";
import { Button, Image } from "react-bootstrap";
import { withTranslation } from "react-i18next";

interface Props {
  label: string;
  clicked: (event: React.MouseEvent<HTMLButtonElement>) => void;
  style: {};
  displayImg: boolean;
  image: string;
  disabled: boolean;
  t: any;
}

const button: React.FunctionComponent<Props> = (props) => {
  const { label, clicked, style, displayImg, image, disabled } = { ...props };
  return (
    <Button className="btn" onClick={clicked} style={style} disabled={disabled}>
      {displayImg && (
        <Image
          src={require("../../../assets/images/" + image)}
          alt=""
          style={{ marginRight: "12px", marginTop: "-3px" }}
        />
      )}
      {label === "Search" && (
        <span className="buttonText">
          {props.t("findProviderPage.searchButton")}
        </span>
      )}

      {label === "Get Started" && (
        <span className="buttonText">
          {props.t("balanceBills.getStartedBtn")}
        </span>
      )}

      {label === "Contact Advocacy" && (
        <span className="buttonText">
          {props.t("balanceBills.contactAdvocacyBtn")}
        </span>
      )}

      {label !== "Search" &&
        label !== "Get Started" &&
        label !== "Contact Advocacy" && (
          <span className="buttonText">{label}</span>
        )}
    </Button>
  );
};

export default withTranslation()(button);
